// extracted by mini-css-extract-plugin
module.exports = {"Client-Article":"client-article_Client-Article__kfoat"};